import { errors } from "@malloc-protocol/sdk";
import { PublicKey } from "@solana/web3.js";
import { ErrorState, errorStore, globalStore, MallocState } from "../globalStore";

export const frontendErrorTypeID = "MALLOC_FLOWCHART_ERROR";

export type FrontendError = {
  type: "MALLOC_FLOWCHART_ERROR";
  msg: string;
  fullError?: any;
};

export const handleError = (e: any) => {
  if (e?.type === frontendErrorTypeID) {
    const eCast = e as FrontendError;
    alert(eCast.msg);
    if (eCast.fullError) throw eCast.fullError;
    throw e;
  } else {
    // const msg = errors.getReadableErrorMessage(e, {
    //   actionNames: getActionVertices(globalStore.state.graph),
    // });
    // alert(`An error occured: ${msg}`);
    throw e;
  }
};

export const ErrorGenerator = {
  TOKEN_ACCOUNT_DOES_NOT_EXIST: (tokAccount: PublicKey | string) =>
    newFrontendError(
      `The token account ${tokAccount.toString()} does not exist`
    ),
  INVALID_AMOUNT_INPUT: (amount: string) =>
    newFrontendError(`${amount} is not a valid number for the input`),
  MINT_ACCOUNT_DOES_NOT_EXIST: (
    mintAccount: PublicKey | string,
    tokAccount?: PublicKey | string
  ) =>
    newFrontendError(
      tokAccount
        ? `The mint ${mintAccount.toString()} found from token ${tokAccount.toString()} does not exist`
        : `The mint ${mintAccount.toString()} does not exist`
    ),
};

export const newFrontendError = (msg: string, e?: any) => {
  return {
    msg,
    fullError: e,
    type: "MALLOC_FLOWCHART_ERROR",
  } as FrontendError;
};

export const setErrorMessage = (
  message: string,
  currErrorState: ErrorState,
  actionName?: string,
) => {
  errorStore.setState({
    ...currErrorState,
    failedAction: actionName,
    changeToggle: !currErrorState.changeToggle,
    message,
  });
};

